import { gql } from '@apollo/client';
import { DiagnosisFragment, InsuranceFragment, PatientFragment } from '@/shared/api';

const NEW_REPORT_DATA_QUERY = gql`
  query newReportData($input: NewReportDataInput) {
    newReportData(input: $input) {
      isSuccess
      message
      reportData {
        holterProfile
        study {
          id
          isArchived
          isDisableAi
          friendlyId
          start
          stop
          studyType
          status
          timezone
          device {
            id
            deviceId
          }
          info {
            patient {
              ...PatientFragment
            }
            insurance {
              ...InsuranceFragment
            }
            diagnosis {
              ...DiagnosisFragment
            }
          }
          timezone
          facility {
            id
            name
            contact {
              fax
              faxes
              country
            }
            faxReportAutomatically
            faxReportManually
            facilityNote
            canSendReportEmail
            timezone
          }
          processingAiStatus
          aiReport {
            status
          }
          isNonPhi
        }
        report {
          id
          reportId
          type
          start
          stop
          status
          technicianComments
          isNotificationReport
          isArtifactReport
          inbox {
            priority
            date
            lastEmailSentAt
          }
          isRenderingBackground
        }
      }
    }
  }

  ${PatientFragment}
  ${InsuranceFragment}
  ${DiagnosisFragment}
`;

export default NEW_REPORT_DATA_QUERY;
